// extracted by mini-css-extract-plugin
module.exports = {"bottombar":"bottombar_bottombar__39Zo9","active":"bottombar_active__J5wYi","play-button":"bottombar_play-button__1SXnL","icon":"bottombar_icon__-Kr-t"};